import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { TranslationService } from 'lipp-components';

/**
 * Web-OAuth-Callback-Route.
 *
 * Wird im Popup-Fenster geladen, das vom OAuthService geoeffnet wurde.
 * Liest code + state aus dem URL-Query und schickt sie per `postMessage`
 * ans Parent-Window. Schliesst sich danach selbst.
 *
 * Sicherheits-Note: `targetOrigin` ist `location.origin` — verhindert dass
 * andere Origins die Message abfangen.
 *
 * Diese Route liegt absichtlich AUSSERHALB von PagesGuard, damit der OAuth-Provider
 * nicht ueber den Auth-Login-Flow gezwungen wird.
 */
@Component({
  selector: 'app-oauth-callback',
  templateUrl: './oauth-callback.component.html',
  styleUrls: ['./oauth-callback.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class OAuthCallbackComponent implements OnInit {
  public message: string = '';

  constructor(private translationService: TranslationService) {}

  public ngOnInit(): void {
    try {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state') ?? '';
      const error = params.get('error');

      const payload = {
        source: 'lipp-oauth',
        code,
        state,
        error,
      };

      if (window.opener) {
        window.opener.postMessage(payload, window.location.origin);
        this.message = error
          ? this.translationService.translate(
              'LippPOS.Dialogs.MailAccount.OAuth.Callback.Failed',
              [error],
            )
          : this.translationService.translate(
              'LippPOS.Dialogs.MailAccount.OAuth.Callback.Success',
            );

        // Kurzes Warten, damit das Parent die Message verarbeiten kann, dann schliessen.
        setTimeout(() => {
          try {
            window.close();
          } catch (_e) {
            // ignore
          }
        }, 500);
      } else {
        this.message = this.translationService.translate(
          'LippPOS.Dialogs.MailAccount.OAuth.Callback.NoOpener',
        );
      }
    } catch (err) {
      this.message = this.translationService.translate(
        'LippPOS.Dialogs.MailAccount.OAuth.Callback.Error',
        [err instanceof Error ? err.message : String(err)],
      );
    }
  }
}
